import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { EnvironmentLoader } from './environments/utils/environment-loader.util';
import { loadExternalAssets } from './app/shared/services/external-assets.service';

async function bootstrapApp() {
  await EnvironmentLoader.loadEnvironment();

  const env = EnvironmentLoader.environment;

  if (env && env.production) {
    enableProdMode();
  }

  loadExternalAssets();

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

bootstrapApp();
